export default __webpack_public_path__ + "static/media/bullhorn.c611ddbd.png";